import { FilterState } from '@/types/enums';
import { S2Selection } from '@/types/s2selection';

export default function (deleteIncluded?: boolean) {
  return deleteIncluded
    ? [
        new S2Selection<FilterState>('All', 'Alle', FilterState.All, null),
        new S2Selection<FilterState>('True', 'Ja', FilterState.Active, null),
        new S2Selection<FilterState>('False', 'Nej', FilterState.Inactive, null)
      ]
    : [
        new S2Selection<FilterState>('All', 'Alle', FilterState.All, null),
        new S2Selection<FilterState>('True', 'Ja', FilterState.Active, null),
        new S2Selection<FilterState>('False', 'Nej', FilterState.Inactive, null)
      ];
}
